module.exports = __webpack_public_path__ + "img/change-card-2-1.svg";